import { PDFReports } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

export const CreateReport = Simple({
  id: '96EA1764-B491-4000-90A8-0A034C66CAF1',
  object: 'Single Report',
  action: 'Create',
  page: PDFReports,
})
